import React from "react";
import { Card, ListGroup} from "react-bootstrap";
import RulesEditOverlapEntry from "./RulesEditOverlapEntry";


class RulesEditOverlap extends React.Component{
    editRuleEntry(index,nval) {
        if(nval == null){
            if(window.confirm("Are you sure you want to remove this rule?")){
                this.props.data[index].delete = true;
                this.props.cb(this.props.data);
            }
        }else{
            this.props.data[index]=nval;
            this.props.data[index].modified = true;
            this.props.cb(this.props.data);
        }
    }
    render(){
        return (

            <Card>
                <Card.Header>
                    <span>Overlap penalty</span>
                </Card.Header>
                <ListGroup variant="flush">
                    {this.props.data.map((val,i) =>
                        val.delete === undefined && val.ruleType === "dist2OtherRules" ? <RulesEditOverlapEntry otherStructs={this.props.otherStructs} key={i} data={val} cb={(nval) => {this.editRuleEntry(i,nval)}}/> : ''
                    )}

                </ListGroup>
            </Card>


        )
    }
}
export default RulesEditOverlap